module.exports = "/static/assets/9de7e20462ee8f25c236dca0172dbc52.png";